<template>
  <div class="d-flex justify-center">
    <div
      class="w-100"
      style="max-width: 440px;"
    >
      <div class="text-center mb-6">
        <v-avatar
          color="primary"
          size="64"
          class="mb-4"
        >
          <v-icon
            icon="fas fa-plug"
            size="28"
          />
        </v-avatar>
        <h1 class="text-headline-medium mb-2">
          {{ t('oauth.title', { client: clientName }) }}
        </h1>
        <p class="text-medium-emphasis">
          {{ t('oauth.intro', { client: clientName, app: appName }) }}
        </p>
      </div>

      <v-card
        variant="outlined"
        class="mb-4"
      >
        <v-list-item
          prepend-icon="fas fa-user"
          :title="userName"
          :subtitle="t('oauth.signed_in_as')"
        />
      </v-card>

      <v-card
        variant="outlined"
        class="mb-4"
      >
        <v-card-text>
          <div class="text-label-large mb-2">
            {{ t('oauth.permissions_heading', { client: clientName }) }}
          </div>
          <v-list
            density="compact"
            class="pa-0"
          >
            <v-list-item
              v-for="scope in scopes"
              :key="scope.id"
              prepend-icon="fas fa-check"
              :title="scopeText(scope)"
              class="px-0"
            />
          </v-list>
        </v-card-text>
      </v-card>

      <v-alert
        type="info"
        variant="tonal"
        density="compact"
        class="mb-6"
        :text="t('oauth.trust_warning')"
      />

      <div class="d-flex ga-3">
        <form
          method="POST"
          action="/oauth/authorize"
          class="flex-1-1"
        >
          <csrf-token />
          <input
            type="hidden"
            name="_method"
            value="DELETE"
          >
          <input
            type="hidden"
            name="state"
            :value="state"
          >
          <input
            type="hidden"
            name="client_id"
            :value="clientId"
          >
          <input
            type="hidden"
            name="auth_token"
            :value="authToken"
          >
          <v-btn
            type="submit"
            variant="outlined"
            color="primary"
            block
            :text="t('actions.cancel')"
          />
        </form>
        <form
          method="POST"
          action="/oauth/authorize"
          class="flex-1-1"
        >
          <csrf-token />
          <input
            type="hidden"
            name="state"
            :value="state"
          >
          <input
            type="hidden"
            name="client_id"
            :value="clientId"
          >
          <input
            type="hidden"
            name="auth_token"
            :value="authToken"
          >
          <v-btn
            type="submit"
            color="secondary"
            block
            :text="t('oauth.allow')"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import CsrfToken from '@/components/CsrfToken.vue';

interface OauthScope {
  id: string;
  description: string;
}

defineProps<{
  clientName: string;
  clientId: string;
  userName: string;
  appName: string;
  authToken: string;
  state: string;
  scopes: OauthScope[];
}>();

const { t, te } = useI18n();

/**
 * The scope's own translation when there is one, otherwise the description
 * the server sent.
 */
function scopeText(scope: OauthScope): string {
  const key = `oauth.scopes.${scope.id.replace(/[^a-z0-9]+/gi, '_')}`;

  return te(key)
    ? t(key)
    : scope.description;
}
</script>
